module.exports = __webpack_public_path__ + "static/img/word02.c7beb5f0.png";